import { Await } from "react-router";
import { HomeContext } from "@app/types/Page";
import CustomError from "@components/Error/CustomError";
import { useHomepageRedirect } from "@hooks/useHomepageRedirect";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import HomeContent from "./HomeContent";

export default function HomePage(): React.ReactElement {
  useHomepageRedirect();

  const { context } =
    useRouteContext<TRouteWithRedirect<HomeContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }) => {
        if (kind === "home") return <HomeContent data={data} />;

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
